import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Popup, Image, List, Radio } from 'antd-mobile'
import { Wrapper, Container, Footer, Header } from '../../../components_renew/Layout'
import { AmountSelector } from '../../../components_renew/common/AmountSelector'
import { YenSpan } from '../../../components_renew/common/YenSpan'
import { ConfirmButton, FooterButton } from '../../../components_renew/Mall/Buttons'
import { requestCartData, requestProductDetailsData, setOrderConfirmData } from '../../../actions/mallAction'
import { requestCouponData } from '../../../actions/couponAction'
import { handleCatch, postMessage } from '../../../utils'
import { filterCouponWithProductId } from '../../../utils/filterTicketWithProduct'
import { withTranslation } from 'react-i18next'

let initTicket = { label: '未选择', value: '', price: 0 }

@withTranslation()
@withRouter
@connect((state, props) => {
  let id = Number(props.match.params.id)
  let { data, loading } = state.mallProductDetails
  let { mallCoupon } = state.couponData
  data = data[id] ? data[id] : {}
  const params = new URLSearchParams(props.location.search)
  return {
    id,
    loading,
    couponList: filterCouponWithProductId(data['productId'], mallCoupon),
    data,
    onlyDisplay: params.get('onlyDisplay'),
  }
})
class ProductDetails extends React.PureComponent {

  state = {
    modalVisible: false,
    couponSelected: initTicket
  }

  // 数量计数器
  counter = { state: { value: 0 } }

  componentDidMount () {

    this.props.dispatch(requestCartData())
    let { id, data, couponList } = this.props
    if (!(couponList.length > 0)) this.props.dispatch(requestCouponData())
    if (!data['id']) {
      this.props.dispatch(requestProductDetailsData({ id }))
    }
  }

  render () {
    let {
      modalVisible,
      couponSelected
    } = this.state

    let { id, couponList, loading, t, onlyDisplay } = this.props

    let {
      currentPrice,
      productPic,
      productDetailPic,
      stock,
      name
    } = this.props.data

    return <Container>
      <Header loading={loading}>{t('product.title')}</Header>
      <Wrapper>
        <div style={{ background: 'var(--adm-color-background)' }}>
          <Image className={'mb-4'} src={productPic} width={'100%'} height={'auto'}/>
          <div>
            <YenSpan color smallSymbol style={{ padding: '1rem', fontSize: '1.5rem' }}>{currentPrice}</YenSpan>
          </div>
          <div className={'p-4 text-lg font-bold'}>
            {name}
          </div>
          <div className={'px-4 text-gray-400 text-xs'}>
            {t('product.stock')}：{stock}
          </div>
          {
            onlyDisplay
              ? <br/>
              : <div className={'p-4 flex justify-between items-center'}>
                <div>规格数量：</div>
                <AmountSelector defaultValue={1} ref={ref => this.counter = ref}
                                max={stock}>{t('product.amount')}</AmountSelector>
              </div>
          }
        </div>
        {
          productPic
            ? <img style={{ width: '100%', height: 'auto' }} src={productDetailPic} alt=""/>
            : null
        }
      </Wrapper>
      {
        onlyDisplay
          ? null
          : <Footer className={'justify-between'}>
            <div>
              {/*<FooterButton icon={'comments'}>联系客服</FooterButton>*/}
              <FooterButton icon={'icon-cart'}
                            onClick={this.routeTo.bind(this, window.PATH.MALL_SHOPPING_CART)}>{t('shop_cart.title')}</FooterButton>
            </div>
            {
              couponList.length > 0
                ? <div style={{ width: 120, textAlign: 'center' }} onClick={this.showModal}>
                  券：{couponSelected.label}
                </div>
                : null
            }
            {
              id ?
                stock > 0
                  ? <div>
                    {/*添加购物车应做个动效*/}
                    <ConfirmButton type={'warning'}
                                   onClick={this.addToCart}>{t('product.add_cart')}</ConfirmButton>
                    <ConfirmButton type={'danger'} onClick={this.buyNow}>{t('product.buy_now')}</ConfirmButton>
                  </div>
                  : <div>
                    <ConfirmButton type={'invalid'}> 暂 无 库 存 </ConfirmButton>
                  </div>
                : null
            }
          </Footer>
      }
      <Popup
        closeOnMaskClick
        showCloseButton
        visible={modalVisible}
        onClose={this.closeModal}
      >
        <List header={<div>请选择用券</div>}>
          <List.Item>
            <Radio checked={'' === couponSelected.value}
                   onChange={this.onCouponChange.bind(this, initTicket)}>不使用</Radio>
          </List.Item>
          {couponList.map((item, index) => (
            <List.Item key={index}>
              <Radio checked={item.value === couponSelected.value}
                     onChange={this.onCouponChange.bind(this, item)}>{item.label}</Radio>
            </List.Item>
          ))}
        </List>
      </Popup>
    </Container>
  }

  showModal = () => {
    this.setState({ modalVisible: true })
  }

  closeModal = () => {
    this.setState({ modalVisible: false })
  }

  routeTo = (path) => {
    this.props.history.push(path)
  }

  onCouponChange = (coupon) => {
    this.setState({ couponSelected: coupon })
  }

  addToCart = () => {
    // 验证登录
    if (!window.axios.getToken()) {
      window.toast.info('请先进行登陆', 1, () => {
        postMessage({ type: 'loginRequest' })
      })
    } else {
      let { id } = this.props
      let { value: amount } = this.counter.state
      let config = {
        method: 'post', url: window.API.Mall.postCartItem,
        data: { productId: id, productCount: amount }
      }
      window.toast.show('')
      window.axios.request(config)
        .then(() => {
          this.props.dispatch(requestCartData())
          window.toast.info('已添加至购物车')
        })
        .catch(handleCatch)
    }
  }

  buyNow = () => {
    // 验证登录
    if (!window.axios.getToken()) {
      window.toast.info('请先进行登陆', 1, () => {
        postMessage({ type: 'loginRequest' })
      })
    } else {
      let { id, data } = this.props
      let { couponSelected } = this.state
      let { value: productCount } = this.counter.state
      Object.assign(data, { productCount, productName: data['name'] })
      let payload = { productList: [data] }
      if (couponSelected['couponId']) Object.assign(payload, { selectedCouponMap: { [String(id)]: couponSelected } })
      this.props.dispatch(setOrderConfirmData(payload))
      this.props.history.push(window.PATH.MALL_ORDER_CONFIRM)
    }
  }
}

export { ProductDetails }
